import { IconCheckFilled, IconErrorFilled } from 'components/Icons';
import Typography from 'components/Typography';
import { htmlId } from 'utils/html';
import { Container, IconWrapper } from './FormSubmitStatus.styles';
import { FormSubmitStatusProps } from './FormSubmitStatus.types';

const FormSubmitStatus = (props: FormSubmitStatusProps) => {
  const { isSuccess, successMessage, errorMessage } = props;
  if (isSuccess)
    return (
      <Container id={htmlId('form-submit-status-container')}>
        <IconWrapper id={htmlId('form-submit-status-icon-conatiner')}>
          <IconCheckFilled />
        </IconWrapper>
        <Typography size='sm'>{successMessage ?? 'Successfully submitted!'}</Typography>
      </Container>
    );

  if (!errorMessage) return null;

  return (
    <Container id={htmlId('form-submit-status-container')}>
      <IconWrapper id={htmlId('form-submit-status-icon-conatiner')}>
        <IconErrorFilled />
      </IconWrapper>
      <Typography size='sm'>{errorMessage}</Typography>
    </Container>
  );
};

export default FormSubmitStatus;
